import { CategoryMenu } from '@framework/types';
import { mapPaginatorData } from '@framework/utils/data-mappers';
import { API_ENDPOINTS } from '@framework/utils/endpoints';
import { useQuery } from 'react-query';
import { CategoriesService, FetchAllCategoriesService } from './categories.service';

type PaginatedCategories = {
  categories: CategoryMenu[];
};

const fetchCategories = async (params: any): Promise<PaginatedCategories> => {
  const {locale, parentId} = params;
  const response = await CategoriesService.all({
    locale: locale, level: "1",  parentId: parentId
  });
  return { categories: response };
};

const useCategoriesQuery = (
  params: any,
  options: any = {}
) => {
  return useQuery<any, Error>([API_ENDPOINTS.FETCH_CATEGORIES, params.parentId], () => fetchCategories(params), {
      ...options,
    }
  );
};

export const fetchCategory = async (params: any) => {
  const response = await CategoriesService.findDetail(params);

  const { products: { data, ...rest }, cateInfo  } = response || {};

  return { products: data, cateInfo, paginatorInfo: mapPaginatorData({ ...rest })};
}

export const useCategoryProductsQuery = (params: any, options: any = {staleTime: Infinity}) => {
  return useQuery<any, Error>([API_ENDPOINTS.CATEGORY_DETAIL, params], () =>
    fetchCategory(params), { ...options }
  );
};


export { useCategoriesQuery, fetchCategories };

export const fetchShopCategories = async (params: any) => {
  const response = await CategoriesService.fetchShopCategories(params);

  return { categories: response };}

export const useShopCategoriesQuery = (params: any, options: any = {staleTime: Infinity}) => {
  return useQuery<any, Error>([API_ENDPOINTS.SHOP_CATEGORIES, params], () =>
    fetchShopCategories(params), { ...options }
  );
};

export const fetchAllCategories = async (params: any): Promise<PaginatedCategories> => {
  const {parentId, categoryIds, categoryDaughterIds, categoryChildIds, type} = params;
  const response = await FetchAllCategoriesService.all({
      level: "3", 
      parentId: parentId || 1,
      categoryIds: categoryIds || [],
      categoryDaughterIds: categoryDaughterIds || [],
      categoryChildIds: categoryChildIds || [],
      type: type != undefined ? "search-product" : ''
  });
  
  const newArray = response.map((item: any) =>  {
    const name = item?.name?.toLowerCase();
    const capitalized = name.charAt(0).toUpperCase() + name.slice(1);

    return {
      ...item,
      name: capitalized
    }
  });

  return { categories: newArray };
};

export const useFetchAllCategoriesQuery = (
  params: any,
  options: any = {}
) => {

  return useQuery<any, Error>([API_ENDPOINTS.FETCH_ALL_CATEGORIES, params], () => fetchAllCategories(params), {
      ...options,
    }
  );
};
